import React, { useEffect, useState } from 'react'
import EmojiData from './EmojiData.json'
import './EmojiData.css'

const EmojiSearch = () => {

    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);

    useEffect(() => {
        const inputdata = EmojiData.filter((element) =>
            element.keywords.toLowerCase().includes(search.toLowerCase()));
        setData(inputdata)
    }, [search])

    return (
        <div className='appcss'>
            <div>
                <i><h1 className='h1text'>EMOJI SEARCH</h1></i>
                <input className='inputt'
                    type="text"
                    placeholder='search'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            <div className="row ">
                {data.map((obj) => {
                    return (
                        <>
                            <div class="card crdd ">
                                <div class="card-body">
                                    <h5 class="card-title">{obj.symbol}</h5>
                                    <i><h5 class="card-text">{obj.title}</h5></i>
                                </div>
                            </div>
                        </>
                    )
                })}

            </div>
        </div>
    )
}

export default EmojiSearch;